/**
 * Dahley Tonia — Main Theme JavaScript
 * Updated: Announcement bar offset, infinite carousel, click-to-PDP.
 */
(function() {
  'use strict';

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ═══ Scroll Reveal ═══ */
  if ('IntersectionObserver' in window && !prefersReduced) {
    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); obs.unobserve(entry.target); }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('.dt-reveal').forEach(function(el) { obs.observe(el); });
  } else {
    document.querySelectorAll('.dt-reveal').forEach(function(el) { el.classList.add('is-visible'); });
  }

  /* ═══ Header scroll + announcement bar offset ═══
     Announcement bar is in normal flow above the fixed header.
     ResizeObserver tracks the announcement bar height for robust
     offset calculation. Dismiss uses class transition, not display:none.
  ═══ */
  var header = document.querySelector('.dt-header');
  var announce = document.querySelector('.dt-announce');
  var announceHeight = 0;

  function measureAnnounce() {
    if (!announce || announce.classList.contains('dt-announce--hidden')) return 0;
    return announce.offsetHeight;
  }

  function updateHeaderPosition() {
    if (!header) return;
    var scrollY = window.scrollY;
    if (scrollY > announceHeight + 10) {
      header.classList.remove('dt-header--transparent');
      header.classList.add('dt-header--solid');
      header.style.top = '0px';
    } else {
      header.classList.add('dt-header--transparent');
      header.classList.remove('dt-header--solid');
      header.style.top = announceHeight + 'px';
    }
  }

  function syncAnnounce() {
    announceHeight = measureAnnounce();
    updateHeaderPosition();
  }

  if (header) {
    syncAnnounce();
    window.addEventListener('scroll', updateHeaderPosition, { passive: true });
    window.addEventListener('resize', syncAnnounce, { passive: true });
    if (announce && typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(syncAnnounce).observe(announce);
    }
  }

  /* ═══ Announcement close ═══ */
  var announceClose = document.querySelector('.dt-announce__close');
  if (announceClose) {
    announceClose.addEventListener('click', function() {
      if (!announce) return;
      announce.classList.add('dt-announce--hidden');
      announceHeight = 0;
      updateHeaderPosition();
    });
    announceClose.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); announceClose.click(); }
    });
  }

  /* ═══ Product Carousel — CSS-TRANSFORM CENTERING (matches React exactly) ═══
     Uses translateX() to always center the active slide.
     Math: translateX = containerWidth/2 - (index * step + cardW/2)
     Infinite wrap via modular arithmetic.
     Drag/swipe with velocity-based snap.
  ═══ */
  document.querySelectorAll('[data-carousel]').forEach(function(carousel) {
    var track = carousel.querySelector('[data-carousel-track]');
    var cards = carousel.querySelectorAll('[data-carousel-card]');
    var prevBtn = carousel.querySelector('[data-carousel-prev]');
    var nextBtn = carousel.querySelector('[data-carousel-next]');
    var dotsContainer = carousel.querySelector('[data-carousel-dots]');
    var infoEl = carousel.querySelector('[data-carousel-info]');
    var carouselContainer = carousel.querySelector('.dt-showcase__carousel');

    if (!track || cards.length === 0) return;

    var active = 0;
    var total = cards.length;
    var isDragging = false;
    var startX = 0;
    var dragDelta = 0;
    var cardW = 220;
    var gap = 20;
    var step = cardW + gap;

    // Disable scroll-based overflow — we use transforms now
    track.style.overflow = 'visible';
    track.style.justifyContent = 'flex-start';
    track.style.flexWrap = 'nowrap';
    track.style.willChange = 'transform';
    if (carouselContainer) {
      carouselContainer.style.overflow = 'hidden';
    }

    // Get container width
    function getContainerWidth() {
      return carouselContainer ? carouselContainer.offsetWidth : carousel.offsetWidth;
    }

    // Calculate translateX to center a given index
    function getCenterX(idx) {
      var cw = getContainerWidth();
      var slideCenter = idx * step + cardW / 2;
      return cw / 2 - slideCenter;
    }

    // Apply transform
    function applyTransform(tx, animate) {
      if (!track) return;
      track.style.transition = animate && !prefersReduced
        ? 'transform 500ms cubic-bezier(0.16, 1, 0.3, 1)'
        : 'none';
      track.style.transform = 'translateX(' + tx + 'px)';
    }

    // Build dot indicators
    if (dotsContainer) {
      dotsContainer.innerHTML = '';
      for (var d = 0; d < total; d++) {
        var dot = document.createElement('button');
        dot.className = 'dt-showcase__dot ' + (d === 0 ? 'dt-showcase__dot--active' : 'dt-showcase__dot--inactive');
        dot.setAttribute('aria-label', 'Go to slide ' + (d + 1));
        dot.addEventListener('click', (function(idx) { return function() { setActive(idx); }; })(d));
        dotsContainer.appendChild(dot);
      }
    }

    function setActive(idx) {
      // INFINITE WRAP
      active = ((idx % total) + total) % total;

      cards.forEach(function(card, i) {
        var isActive = i === active;
        card.classList.toggle('dt-showcase__card--active', isActive);
        card.classList.toggle('dt-showcase__card--inactive', !isActive);
        var img = card.querySelector('.dt-showcase__card-img');
        if (img) {
          img.classList.toggle('dt-showcase__card-img--lg', isActive);
          img.classList.toggle('dt-showcase__card-img--sm', !isActive);
        }
      });

      // Center active card via CSS transform
      var tx = getCenterX(active);
      applyTransform(tx, true);

      // Update info panel
      if (infoEl) {
        var data = cards[active].dataset;
        var productUrl = data.productUrl || '#';
        var variantCount = parseInt(data.variantCount || '1', 10);
        var atcBtn = '';
        if (variantCount > 1) {
          atcBtn = '<button class="btn-shine dt-showcase__atc" data-open-variant-picker data-product-url="' + productUrl + '.js">' +
          '<svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M4 1.3L2 4v9.3a1.3 1.3 0 001.3 1.4h9.4A1.3 1.3 0 0014 13.3V4l-2-2.7H4z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/><path d="M2 4h12" stroke="currentColor" stroke-linecap="round"/><path d="M10.7 6.7a2.7 2.7 0 01-5.4 0" stroke="currentColor" stroke-linecap="round"/></svg>' +
          ' Kies optie</button>';
        } else {
          atcBtn = '<button class="btn-shine dt-showcase__atc" data-add-to-cart="' + (data.variantId || '') + '">' +
          '<svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M4 1.3L2 4v9.3a1.3 1.3 0 001.3 1.4h9.4A1.3 1.3 0 0014 13.3V4l-2-2.7H4z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/><path d="M2 4h12" stroke="currentColor" stroke-linecap="round"/><path d="M10.7 6.7a2.7 2.7 0 01-5.4 0" stroke="currentColor" stroke-linecap="round"/></svg>' +
          ' Toevoegen</button>';
        }
        infoEl.innerHTML =
          '<p class="dt-showcase__label">Dahley Tonia</p>' +
          '<h3 class="dt-showcase__name"><a href="' + productUrl + '">' + (data.name || '') + '</a></h3>' +
          '<p class="dt-showcase__desc">' + (data.desc || '') + '</p>' +
          '<p class="dt-showcase__price">' + (data.price || '') + '</p>' +
          '<p class="dt-showcase__abv">' + (data.abv || '') + '</p>' +
          '<div class="dt-showcase__actions">' + atcBtn +
          '</div>';
      }

      // Update dots
      if (dotsContainer) {
        var dots = dotsContainer.querySelectorAll('.dt-showcase__dot');
        dots.forEach(function(dot, i) {
          dot.className = 'dt-showcase__dot ' + (i === active ? 'dt-showcase__dot--active' : 'dt-showcase__dot--inactive');
        });
      }
    }

    // Card click — inactive cards select, active card navigates to PDP
    cards.forEach(function(card, i) {
      card.addEventListener('click', function(e) {
        if (isDragging) { e.preventDefault(); return; }
        if (i === active) {
          var url = card.dataset.productUrl;
          if (url) window.location.href = url;
        } else {
          e.preventDefault();
          setActive(i);
        }
      });
    });

    // Prev / Next — INFINITE
    if (prevBtn) prevBtn.addEventListener('click', function() { setActive(active - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function() { setActive(active + 1); });

    // Drag / Swipe with real-time transform tracking
    var currentTx = 0;
    var pointerTarget = null;
    track.addEventListener('pointerdown', function(e) {
      if (e.button !== 0) return;
      isDragging = false;
      startX = e.clientX;
      dragDelta = 0;
      pointerTarget = e.target;
      currentTx = getCenterX(active);
      track.setPointerCapture(e.pointerId);
      track.style.transition = 'none';
      track.style.cursor = 'grabbing';
    });
    track.addEventListener('pointermove', function(e) {
      if (startX === 0) return;
      dragDelta = e.clientX - startX;
      if (Math.abs(dragDelta) > 5) isDragging = true;
      track.style.transform = 'translateX(' + (currentTx + dragDelta) + 'px)';
    });
    track.addEventListener('pointerup', function() {
      track.style.cursor = 'grab';
      if (Math.abs(dragDelta) > 50) {
        if (dragDelta < 0) setActive(active + 1);
        else setActive(active - 1);
      } else if (!isDragging && pointerTarget) {
        var tappedCard = pointerTarget.closest('[data-product-url]');
        if (tappedCard) {
          var cardIdx = Array.prototype.indexOf.call(cards, tappedCard);
          if (cardIdx === active) {
            var url = tappedCard.dataset.productUrl;
            if (url) window.location.href = url;
          } else if (cardIdx >= 0) {
            setActive(cardIdx);
          }
        }
        applyTransform(getCenterX(active), true);
      } else {
        applyTransform(getCenterX(active), true);
      }
      startX = 0; dragDelta = 0; pointerTarget = null;
      setTimeout(function() { isDragging = false; }, 50);
    });

    // Recenter on resize
    window.addEventListener('resize', function() {
      applyTransform(getCenterX(active), false);
    });

    setActive(0);
  });

  /* ═══ PDP Quantity Controls ═══ */
  document.querySelectorAll('[data-qty-minus]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var input = this.closest('.dt-pdp__quantity-control').querySelector('input');
      if (input && parseInt(input.value) > 1) input.value = parseInt(input.value) - 1;
    });
  });
  document.querySelectorAll('[data-qty-plus]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var input = this.closest('.dt-pdp__quantity-control').querySelector('input');
      if (input) input.value = parseInt(input.value) + 1;
    });
  });

  /* ═══ Search Overlay ═══ */
  (function() {
    var backdrop = document.getElementById('dt-search-backdrop');
    var modal = document.getElementById('dt-search-modal');
    var input = document.getElementById('dt-search-input');
    var closeBtn = document.getElementById('dt-search-close');
    var resultsContainer = document.getElementById('dt-search-results');
    var searchTimer = null;

    if (!modal || !input) return;

    function fmtPrice(cents) { return String.fromCharCode(8364) + (parseInt(cents) / 100).toFixed(2); }

    function openSearch() {
      backdrop.classList.add('dt-search-backdrop--open');
      modal.classList.add('dt-search-modal--open');
      document.body.style.overflow = 'hidden';
      setTimeout(function() { input.focus(); }, 200);
    }

    function closeSearch() {
      backdrop.classList.remove('dt-search-backdrop--open');
      modal.classList.remove('dt-search-modal--open');
      document.body.style.overflow = '';
      input.value = '';
      resetResults();
    }

    function resetResults() {
      resultsContainer.innerHTML =
        '<p class="dt-search-results__label">Popular Searches</p>' +
        '<div class="dt-search-tags">' +
        ['Vodka','Original','Citrus','Reserve','Gift Set'].map(function(t) {
          return '<button class="dt-search-tag" data-search-tag="' + t + '">' + t + '</button>';
        }).join('') +
        '</div>';
      bindTags();
    }

    function bindTags() {
      resultsContainer.querySelectorAll('[data-search-tag]').forEach(function(tag) {
        tag.addEventListener('click', function() {
          input.value = this.getAttribute('data-search-tag');
          performSearch(input.value);
        });
      });
    }

    function performSearch(q) {
      if (!q.trim()) { resetResults(); return; }
      resultsContainer.innerHTML = '<div class="dt-search-loading"><div class="dt-search-loading__spinner"></div><span>Searching...</span></div>';
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=4')
        .then(function(r) { return r.json(); })
        .then(function(data) {
          var products = data.resources && data.resources.results && data.resources.results.products ? data.resources.results.products : [];
          if (products.length === 0) {
            resultsContainer.innerHTML = '<div class="dt-search-empty"><p>No results for "' + q + '"</p><p style="margin-top:8px;font-size:12px;color:rgba(255,255,255,0.2);">Try a different search term or browse our collection.</p></div>';
            return;
          }
          var html = '<p class="dt-search-results__label">Producten (' + products.length + ')</p>';
          products.forEach(function(p) {
            var img = p.image || p.featured_image || '';
            html += '<a href="' + p.url + '" class="dt-search-item">';
            html += '<div class="dt-search-item__img"><img src="' + img + '" alt="' + p.title + '" loading="lazy"></div>';
            html += '<div style="flex:1;min-width:0;">';
            html += '<p class="dt-search-item__name">' + p.title + '</p>';
            if (p.body) html += '<p class="dt-search-item__meta">' + p.body.substring(0, 60) + '...</p>';
            html += '</div>';
            if (p.price) html += '<span class="dt-search-item__price">' + fmtPrice(p.price) + '</span>';
            html += '</a>';
          });
          html += '<a href="/search?q=' + encodeURIComponent(q) + '" class="dt-search-viewall">Bekijk alle resultaten <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="14,7 19,12 14,17"/></svg></a>';
          resultsContainer.innerHTML = html;
        })
        .catch(function() { resultsContainer.innerHTML = '<div class="dt-search-empty">Zoeken niet beschikbaar</div>'; });
    }

    input.addEventListener('input', function() {
      clearTimeout(searchTimer);
      var q = this.value;
      searchTimer = setTimeout(function() { performSearch(q); }, 200);
    });

    input.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeSearch();
      if (e.key === 'Enter') {
        e.preventDefault();
        var firstLink = resultsContainer.querySelector('.dt-search-item');
        if (firstLink) firstLink.click();
        else if (input.value.trim()) window.location.href = '/search?q=' + encodeURIComponent(input.value);
      }
    });

    if (closeBtn) closeBtn.addEventListener('click', closeSearch);
    if (backdrop) backdrop.addEventListener('click', closeSearch);

    document.querySelectorAll('[data-open-search]').forEach(function(btn) {
      btn.addEventListener('click', function(e) { e.preventDefault(); openSearch(); });
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal.classList.contains('dt-search-modal--open')) closeSearch();
    });

    bindTags();
  })();

})();
